import { render, staticRenderFns } from "./DashboardSettings.vue?vue&type=template&id=6488d4fc&scoped=true&"
import script from "./DashboardSettings.vue?vue&type=script&lang=js&"
export * from "./DashboardSettings.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSettings.vue?vue&type=style&index=0&id=6488d4fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6488d4fc",
  null
  
)

export default component.exports